var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { positive, info, warning, negative, pending, color1, color2, color3, color4, color5, color6, color7, color8, color9, color10, color11, color12, itemContainerClickable, } from '../styles';
import { positive as positiveCitron, info as infoCitron, warning as warningCitron, negative as negativeCitron, pending as pendingCitron, color1 as color1Citron, color2 as color2Citron, color3 as color3Citron, color4 as color4Citron, color5 as color5Citron, color6 as color6Citron, color7 as color7Citron, color8 as color8Citron, color9 as color9Citron, color10 as color10Citron, color11 as color11Citron, color12 as color12Citron, itemContainerClickable as itemContainerClickableCitron, } from '../styles/citron';
import { Styled } from './List.styled';
import { getAutomation, getDebug, getStyleNames } from '@citrus/runtime';
import { getChildByType, removeChildrenByType } from 'react-nanny';
import { get, isNotNullOrEmpty } from '@pcty/utils';
import { useTheme } from '@citrus/user';
var VERSION = '2.7.0';
/** DISPLAY NAME: &lt;List.Item&gt; */
var ListItem = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, renderActionArea = _a.renderActionArea, ribbon = _a.ribbon, _d = _a.__TYPE, TYPE = _d === void 0 ? 'ListItem' : _d, other = __rest(_a, ["automationId", "children", "className", "css", "disabled", "onClick", "renderActionArea", "ribbon", "__TYPE"]);
    var _e = useTheme(), isCitron = _e.citrus2022, isLegacy = _e.legacy;
    var emotionObj = (_b = {},
        _b[emotionCss(itemContainerClickable)] = isLegacy && isNotNullOrEmpty(onClick),
        _b[emotionCss(itemContainerClickableCitron)] = isCitron && isNotNullOrEmpty(onClick),
        _b[emotionCss(color1)] = isLegacy && (ribbon === 'color1' || ribbon === 'info'),
        _b[emotionCss(color2)] = isLegacy && ribbon === 'color2',
        _b[emotionCss(color3)] = isLegacy && (ribbon === 'color3' || ribbon === 'positive'),
        _b[emotionCss(color4)] = isLegacy && ribbon === 'color4',
        _b[emotionCss(color5)] = isLegacy && ribbon === 'color5',
        _b[emotionCss(color6)] = isLegacy && (ribbon === 'color6' || ribbon === 'warning'),
        _b[emotionCss(color7)] = isLegacy && ribbon === 'color7',
        _b[emotionCss(color8)] = isLegacy && ribbon === 'color8',
        _b[emotionCss(color9)] = isLegacy && ribbon === 'color9',
        _b[emotionCss(color10)] = isLegacy && ribbon === 'color10',
        _b[emotionCss(color11)] = isLegacy && ribbon === 'color11',
        _b[emotionCss(color12)] = isLegacy && ribbon === 'color12',
        _b[emotionCss(negative)] = isLegacy && ribbon === 'negative',
        _b[emotionCss(pending)] = isLegacy && ribbon === 'pending',
        _b[emotionCss(color1Citron)] = isCitron && ribbon === 'color1',
        _b[emotionCss(color2Citron)] = isCitron && ribbon === 'color2',
        _b[emotionCss(color3Citron)] = isCitron && ribbon === 'color3',
        _b[emotionCss(color4Citron)] = isCitron && ribbon === 'color4',
        _b[emotionCss(color5Citron)] = isCitron && ribbon === 'color5',
        _b[emotionCss(color6Citron)] = isCitron && ribbon === 'color6',
        _b[emotionCss(color7Citron)] = isCitron && ribbon === 'color7',
        _b[emotionCss(color8Citron)] = isCitron && ribbon === 'color8',
        _b[emotionCss(color9Citron)] = isCitron && ribbon === 'color9',
        _b[emotionCss(color10Citron)] = isCitron && ribbon === 'color10',
        _b[emotionCss(color11Citron)] = isCitron && ribbon === 'color11',
        _b[emotionCss(color12Citron)] = isCitron && ribbon === 'color12',
        _b[emotionCss(negativeCitron)] = isCitron && ribbon === 'negative',
        _b[emotionCss(pendingCitron)] = isCitron && ribbon === 'pending',
        _b[emotionCss(infoCitron)] = isCitron && ribbon === 'info',
        _b[emotionCss(positiveCitron)] = isCitron && ribbon === 'positive',
        _b[emotionCss(warningCitron)] = isCitron && ribbon === 'warning',
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b);
    var classes = cx(emotionObj, className || '');
    var styleNames = {
        itemContainerClickable: emotionObj[emotionCss(itemContainerClickable)] || emotionObj[emotionCss(itemContainerClickableCitron)],
        color1: emotionObj[emotionCss(color1)] || emotionObj[emotionCss(color1Citron)],
        color2: emotionObj[emotionCss(color2)] || emotionObj[emotionCss(color2Citron)],
        color3: emotionObj[emotionCss(color3)] || emotionObj[emotionCss(color3Citron)],
        color4: emotionObj[emotionCss(color4)] || emotionObj[emotionCss(color4Citron)],
        color5: emotionObj[emotionCss(color5)] || emotionObj[emotionCss(color5Citron)],
        color6: emotionObj[emotionCss(color6)] || emotionObj[emotionCss(color6Citron)],
        color7: emotionObj[emotionCss(color7)] || emotionObj[emotionCss(color7Citron)],
        color8: emotionObj[emotionCss(color8)] || emotionObj[emotionCss(color8Citron)],
        color9: emotionObj[emotionCss(color9)] || emotionObj[emotionCss(color9Citron)],
        color10: emotionObj[emotionCss(color10)] || emotionObj[emotionCss(color10Citron)],
        color11: emotionObj[emotionCss(color11)] || emotionObj[emotionCss(color11Citron)],
        color12: emotionObj[emotionCss(color12)] || emotionObj[emotionCss(color12Citron)],
        info: emotionObj[emotionCss(info)] || emotionObj[emotionCss(infoCitron)],
        positive: emotionObj[emotionCss(positive)] || emotionObj[emotionCss(positiveCitron)],
        warning: emotionObj[emotionCss(warning)] || emotionObj[emotionCss(warningCitron)],
        negative: emotionObj[emotionCss(negative)] || emotionObj[emotionCss(negativeCitron)],
        pending: emotionObj[emotionCss(pending)] || emotionObj[emotionCss(pendingCitron)],
    };
    var checkbox = getChildByType(children, ['ListCheckbox']);
    if (isNotNullOrEmpty(checkbox)) {
        checkbox = React.cloneElement(checkbox, { disabled: disabled });
    }
    children = removeChildrenByType(children, ['ListCheckbox']);
    var checked = get(checkbox, 'props.checked', false);
    var Item = getItem(checked, disabled);
    var Container = getContainer(checked, disabled);
    return (React.createElement(Container, __assign({ className: classes, onClick: function (e) {
            e.stopPropagation();
            return !disabled &&
                e.target.nodeName.toLowerCase() !== 'button' &&
                e.target.nodeName.toLowerCase() !== 'i' &&
                onClick
                ? onClick()
                : undefined;
        }, ref: ref, styleNames: getStyleNames(styleNames) }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)),
        checkbox,
        React.createElement(Item, null, children),
        _renderActionArea(renderActionArea, checked, disabled)));
});
var _renderActionArea = function (renderActionArea, checked, disabled) {
    if (!renderActionArea)
        return;
    var Actions = checked ? Styled.ActionsSelected : Styled.Actions;
    if (checked && disabled) {
        Actions = Styled.ActionsSelectedDisabled;
    }
    return React.createElement(Actions, null, renderActionArea());
};
var getItem = function (checked, disabled) {
    if (disabled && checked)
        return Styled.ItemSelectedDisabled;
    return checked ? Styled.ItemSelected : Styled.Item;
};
var getContainer = function (checked, disabled) {
    if (disabled)
        return Styled.ItemContainerDisabled;
    return checked ? Styled.ItemContainerSelected : Styled.ItemContainer;
};
ListItem.defaultProps = {
    __TYPE: 'ListItem',
};
export default ListItem;
